module.exports = __webpack_public_path__ + "img/a@2x.9ec4e821.jpg";